import React, { useState } from 'react';
import { Link } from 'react-router-dom';
import { ChevronRight } from 'lucide-react';
import { Button } from './ui/Button';
import { AgencyModal } from './AgencyModal';
export const CTA = () => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  return <section className="py-24 bg-white" data-id="element-344">
      <AgencyModal isOpen={isModalOpen} onClose={() => setIsModalOpen(false)} data-id="element-345" />
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8" data-id="element-346">
        <div className="bg-zano-charcoal rounded-3xl p-10 md:p-16 text-center text-white relative overflow-hidden" data-id="element-347">
          <div className="absolute top-0 right-0 w-64 h-64 bg-white/5 rounded-full blur-3xl -translate-y-1/2 translate-x-1/2" data-id="element-348"></div>
          <div className="absolute bottom-0 left-0 w-64 h-64 bg-zano-pink/20 rounded-full blur-3xl translate-y-1/2 -translate-x-1/2" data-id="element-349"></div>

          <div className="relative z-10 max-w-3xl mx-auto" data-id="element-350">
            <h2 className="text-3xl md:text-5xl font-bold mb-6" data-id="element-351">
              Access the elite layer of talent representation
            </h2>
            <p className="text-lg text-gray-300 mb-10" data-id="element-352">
              Brand, marketing agency, or talent team — join the discovery layer
              for represented influencers.
            </p>

            <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-16" data-id="element-353">
              <Button variant="secondary" className="bg-transparent text-white border-gray-600 hover:bg-gray-800 hover:border-gray-500 w-full sm:w-auto px-8 py-3" onClick={() => setIsModalOpen(true)} data-id="element-354">
                List Your Agency
              </Button>
              <Link to="/pricing" data-id="element-355">
                <Button variant="primary" className="bg-white text-zano-charcoal hover:bg-gray-100 w-full sm:w-auto px-8 py-3" data-id="element-356">
                  Start Free Trial
                </Button>
              </Link>
            </div>

            <div className="grid grid-cols-1 md:grid-cols-3 gap-6 text-left" data-id="element-357">
              <div className="bg-gray-800/50 backdrop-blur-sm p-6 rounded-xl border border-gray-700" data-id="element-358">
                <h3 className="font-semibold text-white mb-2" data-id="element-359">Brands</h3>
                <p className="text-sm text-gray-400 mb-4" data-id="element-360">
                  Source represented talent and connect with managers directly.
                </p>
                <a href="#" className="text-sm font-medium text-white hover:text-gray-300 flex items-center gap-1" data-id="element-361">
                  Learn more <ChevronRight size={16} data-id="element-362" />
                </a>
              </div>
              <div className="bg-gray-800/50 backdrop-blur-sm p-6 rounded-xl border border-gray-700" data-id="element-363">
                <h3 className="font-semibold text-white mb-2" data-id="element-364">
                  Marketing Agencies
                </h3>
                <p className="text-sm text-gray-400 mb-4" data-id="element-365">
                  Source fast and manage existing talent agency partners.
                </p>
                <a href="#" className="text-sm font-medium text-white hover:text-gray-300 flex items-center gap-1" data-id="element-366">
                  Learn more <ChevronRight size={16} data-id="element-367" />
                </a>
              </div>
              <div className="bg-gray-800/50 backdrop-blur-sm p-6 rounded-xl border border-gray-700" data-id="element-368">
                <h3 className="font-semibold text-white mb-2" data-id="element-369">
                  Talent Agencies
                </h3>
                <p className="text-sm text-gray-400 mb-4" data-id="element-370">
                  Turn your roster into bookable, always-live public media kits.
                </p>
                <a href="#" className="text-sm font-medium text-white hover:text-gray-300 flex items-center gap-1" data-id="element-371">
                  Learn more <ChevronRight size={16} data-id="element-372" />
                </a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};